<template>
    <Row :gutter="20" class="grid-header mx-0" type="flex">
        <Col
          v-if="!noCheckbox"
          :span="1">
          <span v-if="deselectAll">
            <Checkbox checked  @change="clearAll()"></Checkbox>
          </span>
          <span v-else-if="!hideSelectAll">
            <Checkbox :value="isChecked" @change="selectAll($event)"></Checkbox>
          </span>
        </Col>
        <Col
          v-for="(header,index) in headers"
          :key="index"
          v-if="canShowHeader(header)"
          :span="header.colSpan"
          :class="{'text-center':header.subColumnCount && !header.alignLeft}">
            <span>{{header.tlabel ? $t(header.tlabel) : header.title}}</span>
            <Row v-if="header.subColumnCount">
              <Col class="text-center"
                v-for="(header2,index) in header.subColumns"
                :key="index"
                :span="header2.colSpan">
                  <div class="grid-content bg-purple-dark">
                    {{header2.tlabel ? $t(header2.tlabel) : header2.title}}
                  </div>
              </Col>
            </Row>
        </Col>
        <Col v-if="hasColumnPicker" class="col-push text-right">
        <Popover placement="bottom-end" :visible-arrow="false" class="popover-icon" popper-class="popover-list" v-if="showHeaderToggle" >
            <div slot="reference">
                <span :underline="false">
                    <svgicon name="ColumnMenu" width="13" height="13" :original="true" />
                </span>
            </div>
            <div class="popover-wrapper">
                <div class="popover-header">
                    <h6>{{$t('HEADER_COLUMN_PICKER')}}</h6>
                    <small>{{$t('HEADER_MAX_DISPLAY_COLUMN',{maxDisplayColumn: maxDisplayColumn})}}</small>
                </div>
                <div class="popover-body popover-scroll">
                    <ul class="list-popover list-popover-icon">
                        <li
                          v-for="(header,index) in headers"
                          :key="index">
                            <SwitchBtn
                                v-model="header.show"
                                :active-text="header.tlabel ? $t(header.tlabel) : header.title"
                                :disabled="disableSelection(header)"
                                class="default-switch"
                                >
                            </SwitchBtn>
                        </li>
                    </ul>
                </div>
            </div>
        </Popover>
        </Col>
    </Row>
</template>
<script>
import { maxColSpan } from '@common/constants/globalConstants';

export default {
  props:['headers','maxDisplayColumn','hasColumnPicker','deselectAll','noCheckbox', 'hideSelectAll', 'isChecked'],
  data() {
    return {
      maxColSpan,
    }
  },
  computed: {
    showHeaderToggle() {
      const flag = (this.headers.length === this.maxDisplayColumn) ? false : true;
      return flag;
    },
    actionSpan() {
      if(this.headers) {
        return this.maxColSpan - this.headers.reduce((accumulator, header) => {
          if(header.hasOwnProperty('show')? header.show:true) {
            accumulator += parseFloat(header.colSpan);
          }
          return accumulator;
        }, 0);
      }
      return 0;
    },
  },
  methods: {
    canShowHeader(header) {
      return header.hasOwnProperty('show')? header.show:true;
    },
    disableSelection(header) {
      const count = this.selectedColumnLength() + (header.subColumnCount || 1);
      return count > this.maxDisplayColumn && !header.show;
    },
    selectedColumnLength() {
      if(this.headers) {
        const count =  this.headers.reduce((total, header) => {
        if(header.show) {
          total += header.subColumnCount || 1;
        }
        return total;
        }, 0);
        return count;
      }
      return 0;
    },
    selectAll(value) {
      this.$emit('selectAll',value);
    },
  },
}
</script>
